import React, { useState, useEffect } from 'react';
import { AnimatePresence } from 'framer-motion'; 
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import './App.css';

// Import components
import GameDetailView from './components/GameDetailView';
import Root from './Root';

// Import pages
import HomePage from './pages/HomePage';
import GamesPage from './pages/GamePage';
import AboutPage from './pages/AboutPage';
import FeaturesPage from './pages/FeaturesPage';
import TechnologyPage from './pages/TechnologyPage';
import SupportPage from './pages/SupportPage';
import StartUpGuide from './pages/StartUpGuide';
import ContactPage from './pages/ContactPage';
import PrivacyPage from './pages/PrivacyPage';
import EulaPage from './pages/EulaPage';
import BaaPage from './pages/BaaPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  const [games, setGames] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedGame, setSelectedGame] = useState(null);

  // Router that directs users to certain pages depending on URL
  const router = createBrowserRouter(createRoutesFromElements(
    <Route path="/" element={ <Root/>}>
      <Route index element={ <HomePage/>}/>
      <Route path="home" element={ <HomePage/> }></Route>
      <Route path="about" element={ <AboutPage/> }></Route>
      <Route path="games" element={ <GamesPage 
        games={games} 
        isLoading={isLoading} 
        onGameSelect={setSelectedGame}/> }>
      </Route>
      <Route path="games/:name" element={ <GameDetailView games={games} />}/>
      <Route path="features" element={ <FeaturesPage/> }></Route>
      <Route path="tech" element={ <TechnologyPage/> }></Route>
      <Route path="support" element={ <SupportPage/> }></Route>
      <Route path="startup-guide" element={ <StartUpGuide/> }></Route>
      <Route path="contact-us" element={ <ContactPage/> }></Route>
      <Route path="privacy-policy" element={ <PrivacyPage/> }></Route>
      <Route path="EULA" element={ <EulaPage/> }></Route>
      <Route path="BAA" element={ <BaaPage/> }></Route>
      <Route path="*" element={ <NotFoundPage/> }></Route>
    </Route>
  ));

  useEffect(() => {
    fetch('/sample.json')
      .then(response => response.json())
      .then(data => {
        const gamesArray = data.games || data;
        
        const processedGames = gamesArray.map(game => ({
          id: game._id || game.id,
          name: game.name,
          description: game.description,
          thumbnail: game.image?.[0]?.uri || game.thumbnail,
          category: game.legacyData?.category || game.category || 'General',
          difficulty: game.legacyData?.difficulty || game.difficulty || 'Medium',
          duration: game.legacyData?.duration || game.duration || 'Flexible',
          metrics: game.legacyData?.metrics || game.metrics || [],
          tags: game.legacyData?.tags || game.tags || [],
          lastUpdated: game.legacyData?.lastUpdated || game.lastUpdated,
          ...game
        }));
        
        setGames(processedGames);
        setIsLoading(false);
      })
      .catch(error => {
        console.error("Error:", error);
        setIsLoading(false);
      });
  }, []);

  return (
    <div className="app-content">
      <AnimatePresence mode="wait">
        <RouterProvider router={router}/>
      </AnimatePresence>
    </div>
  );
  /*
  {selectedGame ? (
            <div className="app-container">
              <GameDetailView 
                game={selectedGame} 
                onClose={() => setSelectedGame(null)} 
              />
            </div>
          ) : (
            <>
              {currentPage === 'home' && <HomePage setCurrentPage={setCurrentPage} />}
  */
}

export default App;